import {fetchAssignees} from '@github-ui/item-picker-assignee-tsq'
import {getActorCapabilities} from '@github-ui/item-picker-assignee-tsq/utils/assignee-picker'
import {useQuery, useQueryClient} from '@github-ui/react-query'

export function useAssigneesQuery({
  owner,
  repo,
  assignees,
}: {
  owner: string | undefined
  repo: string | undefined
  assignees: string[] | undefined
}) {
  const queryClient = useQueryClient()
  const capabilities = getActorCapabilities({includeAuthorableBots: false, includeAssignableBots: true})
  const queryKey = ['copilot-immersive-assignees', JSON.stringify(queryClient), capabilities, owner, repo, assignees]

  const queryFn = async () => {
    if (!owner || !repo || !assignees) return []

    // TSQ implementation uses loginNames parameter to fetch specific assignees
    const response = await fetchAssignees(queryClient, {
      owner,
      repo,
      query: '',
      loginNames: assignees,
      capabilities,
    })
    return response.assignees
  }

  return useQuery({
    queryKey,
    queryFn,
  })
}
